import addSkipPicker from './addSkipPicker';

const usePickerFor = (pickerName,isWaiting) => {
    const pn = pickerName.toLowerCase();
    let pickerInfo = {//initial state
        icon: "mybsw",
        iconSet: "brand",
        message: "I'd like to view information for",
        toUrl: `/${pn}`,
        countField: "count"
    };
    if (!isWaiting) {
        try {
            switch (pn) {
                case 'test':
                    pickerInfo = { icon: "social-support", iconSet: "brand", message: "Pick your proxy maan", toUrl: "/messagesAll", countField: "count"};
                    break;
                case 'messagesall':
                    pickerInfo = { icon: "social-support", iconSet: "brand", message: "I'd like to view messages for", toUrl: `/messagesAll`, name: "messages", countField: "unreadCount" };
                    break;
                case 'messages':
                    pickerInfo = { icon: "social-support", iconSet: "brand", message: "I'd like to view messages for", toUrl: `/messagesAll`, name: "messages", countField: "unreadCount" };
                    break;
                case 'testresults':
                    pickerInfo = { icon: "pulse", iconSet: "brand", message: "I’d like to view test results for", toUrl: "/testresults", name: "testResults", countField: "unreadCount" };
                    break;
                case 'currentmeds':
                    pickerInfo = { icon: "pills", iconSet: "brand", message: "I’d like to view medications for", toUrl: `/${pn}`, countField: "count" };
                    break;
                case 'rxcurrentmeds':
                    pickerInfo = {
                        icon: "pills", iconSet: "brand", message: "I’d like to view medications for", toUrl: `/currentmeds`, countField: "count"};
                    break;
                case 'accountsummary':
                    pickerInfo = { icon: "money", iconSet: "brand", message: "I'd like to view bills for", toUrl: `/${pn}`, countField: "count" };
                    break;
                case 'vaccinecredentials':
                    pickerInfo = { icon: "covid-19-vaccine", iconSet: "brand", message: "I'd like to view COVID-19 vaccine credentials for", toUrl: `/${pn}`, countField: "count" };
                    break;
                case 'appointments':
                    pickerInfo = { icon: "appointments", iconSet: "brand", message: "I’d like to view appointments for", toUrl: `/${pn}`, countField: "count" };
                    break;
                case 'letters':
                    pickerInfo = { icon: "social-support", iconSet: "brand", message: "I'd like to view letters for", toUrl: `/${pn}`, countField: "count" };
                    break;
                case 'carecompanion':
                    pickerInfo = { icon: "mybsw", iconSet: "brand", message: "I'd like to view care companion for", toUrl: `/${pn}`, countField: "count", disabled: (item) => { return !item.careCompanion.isCareCompanion; } };
                    break;
                default:
                    pickerInfo = { icon: "mybsw", iconSet: "brand", message: "I'd like to view information for", toUrl: `/${pn}`, countField: "count" };
                    break;
            }
            pickerInfo=addSkipPicker(pn,pickerInfo);
        } catch (e) {
            console.info(`usePicker for ${pn} faled`, e);
        }
    }
    return pickerInfo;
}

export default usePickerFor ;